import type {UndoableState} from '../../vendor/src/features/remotion-editor/editor/state/types';
import {workMediaAssets, prepareWorkAsset, type WorkMediaAsset} from './work-asset-library';
import {readVideoGenerationReceipt} from '../../protocol/video-generation-receipt';

export type GeneratedSourceFilter = 'all' | 'video' | 'audio';
export type GeneratedSourceAsset = Extract<WorkMediaAsset, {type: 'video' | 'audio'}>;

const nonempty = (value: unknown): value is string => typeof value === 'string' && value.trim().length > 0;

/** Lineage belongs to the source asset, independent of its name or current placements. */
export function isGeneratedSource(asset: WorkMediaAsset): asset is GeneratedSourceAsset {
  if (asset.type === 'video') return 'wakaContinuationId' in asset && nonempty(asset.wakaContinuationId);
  if (asset.type !== 'audio') return false;
  if ('wakaSpeechId' in asset && nonempty(asset.wakaSpeechId)) return true;
  if (!('wakaSpeech' in asset) || !asset.wakaSpeech || typeof asset.wakaSpeech !== 'object') return false;
  const speech = asset.wakaSpeech;
  return 'sourceUrl' in speech && nonempty(speech.sourceUrl) && speech.sourceUrl === asset.remoteUrl;
}

export function generatedSourceAssets(document: Pick<UndoableState, 'assets' | 'items'>, filter: GeneratedSourceFilter = 'all') {
  return workMediaAssets(document).flatMap(({asset, placements}) => {
    if(!isGeneratedSource(asset)||(filter!=='all'&&asset.type!==filter))return [];
    const receipt=asset.type==='video'&&'wakaVideoGeneration' in asset?readVideoGenerationReceipt(asset.wakaVideoGeneration):undefined;
    return [{asset,placements,receipt}];
  }).sort((a,b)=>{
    const left=a.receipt?Date.parse(a.receipt.receivedAt):-Infinity,right=b.receipt?Date.parse(b.receipt.receivedAt):-Infinity;
    return left===right?0:right-left;
  });
}

/** Revalidate against the current document when adding, including after a document switch. */
export function prepareGeneratedSource(document: UndoableState, assetId: string, itemId: string, from: number) {
  const prepared = prepareWorkAsset(document, assetId, itemId, from);
  if (!isGeneratedSource(prepared.asset)) throw new Error('현재 작업에서 생성 원본을 다시 선택해 주세요.');
  return {...prepared, asset: prepared.asset};
}
